import React, {
  Fragment,
  useState,
  useContext,
  useEffect,
  useRef,
} from "react";

import { makeStyles } from "@material-ui/core/styles";
import { Grid, Link, Card, Typography, Divider } from "@material-ui/core";

import Spinner from "../../layout/Spinner";

import DisputeContext from "../../../context/paypal/disputes/DisputeContext";
import DisputeResultOrder from "./DisputeResultOrder";
import PaypalFunctionsHome from "./PaypalFunctions/PaypalFunctionsHome";
import FunctionSendMessage from "./PaypalFunctions/FunctionSendMessage";

const DisputeResult = ({
  sendDisputeID,
  state,
  setState,
  returnedMsg,
  setReturnedMsg,
}) => {
  // Initiate Local State
  const disputeContext = useContext(DisputeContext);
  const { loading, dispute, order, getDisputeById, returnedData } =
    disputeContext;

  const [disputeItem, setDisputeItem] = useState();
  const [disputeMessages, setDisputeMessages] = useState([]);

  // Check functions in links
  const [linkSendMessage, setLinkSendMessage] = useState(true);
  const [linkProvideSupportInfo, setLinkProvideSupportInfo] = useState(false);
  const [linkAcceptClaim, setLinkAcceptClaim] = useState(false);
  const [linkAppeal, setLinkAppeal] = useState(false);
  const [linkProvideEvidence, setLinkProvideEvidence] = useState(false);
  const [linkEscalate, setLinkEscalate] = useState(false);
  const [linkMakeOffer, setLinkMakeOffer] = useState(false);
  const [linkAcknowledge, setLinkAcknowledge] = useState(false);

  // References
  const got_orderRef = useRef(state.got_order);
  got_orderRef.current = state.got_order;

  useEffect(() => {
    if (dispute && Object.keys(dispute).length > 0) {
      setState((state) => ({
        ...state,
        message_value: "",
        errors: {
          message_value: "",
        },
      }));
      setDisputeItem(dispute);
      // getDisputeById
      if (got_orderRef.current === false) {
        setState((state) => ({
          ...state,
          got_order: true,
        }));
      }
    } else {
      // Errors - no value return
      setState((state) => ({
        ...state,
        got_order: false,
      }));
    }
    //eslint-disable-next-line
  }, [dispute]);

  useEffect(() => {
    if (order && Object.keys(order).length > 0) {
      // getDisputeById
      if (got_orderRef.current === false) {
        setState((state) => ({
          ...state,
          got_order: true,
        }));
      }
    } else {
      // Errors - no value return
      setState((state) => ({
        ...state,
        got_order: false,
      }));
    }
    //eslint-disable-next-line
  }, [order]);

  useEffect(() => {
    setDisputeItem();
    getDisputeById(sendDisputeID);
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    let errors = "";
    let success = "";
    if (dispute) {
      const linksArray = [];
      if (
        returnedData &&
        typeof returnedData.returnedData === "object" &&
        returnedData.returnedData.dispute_id === dispute.dispute_id
      ) {
        for (let x in returnedData.returnedData.links) {
          linksArray.push(returnedData.returnedData.links[x]["rel"]);
        }
      } else if (dispute.links) {
        for (let x in dispute.links) {
          linksArray.push(dispute.links[x]["rel"]);
        }
      }
      if (returnedData && returnedData.returnedData !== returnedMsg) {
        setReturnedMsg(returnedData.returnedData);
        if (typeof returnedData.returnedData === "object") {
          setDisputeMessages(returnedData.returnedData.messages);
          errors = "";
          success = true;
        } else {
          errors = returnedData.returnedData;
          success = false;
        }
        setState((state) => ({
          ...state,
          message_value: "",
          errors: {
            message_value: errors,
          },
          success_alert: success,
        }));
        setTimeout(() => {
          setState((state) => ({
            ...state,
            errors: {
              message_value: "",
            },
            success_alert: "",
          }));
        }, 5000);
      } else {
        setDisputeMessages(dispute.messages);
      }

      if (linksArray.indexOf("send_message") >= 0) {
        setLinkSendMessage(false);
      } else {
        setLinkSendMessage(true);
      }
      if (linksArray.indexOf("provide_supporting_info") >= 0) {
        setLinkProvideSupportInfo(true);
      } else {
        setLinkProvideSupportInfo(false);
      }
      if (linksArray.indexOf("accept_claim") >= 0) {
        setLinkAcceptClaim(true);
      } else {
        setLinkAcceptClaim(false);
      }
      if (linksArray.indexOf("appeal") >= 0) {
        setLinkAppeal(true);
      } else {
        setLinkAppeal(false);
      }
      if (linksArray.indexOf("provide_evidence") >= 0) {
        setLinkProvideEvidence(true);
      } else {
        setLinkProvideEvidence(false);
      }
      if (linksArray.indexOf("escalate") >= 0) {
        setLinkEscalate(true);
      } else {
        setLinkEscalate(false);
      }
      if (linksArray.indexOf("make_offer") >= 0) {
        setLinkMakeOffer(true);
      } else {
        setLinkMakeOffer(false);
      }
      if (linksArray.indexOf("acknowledge_return_item") >= 0) {
        setLinkAcknowledge(true);
      } else {
        setLinkAcknowledge(false);
      }
    }
    //eslint-disable-next-line
  }, [returnedData, dispute]);

  const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
    },
    cardHeader: {
      backgroundColor: theme.palette.primary.dark,
      height: 60,
      paddingLeft: theme.spacing(2),
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
    },
    cardBody: {
      padding: theme.spacing(2),
    },
    headerText: {
      color: theme.palette.primary.contrastText,
    },
    card: {
      height: 590,
      backgroundColor: "#FFFFFF",
    },
    cardItem: {
      paddingLeft: theme.spacing(1),
    },
    chip: {
      fontSize: 11,
    },
  }));

  const classes = useStyles();

  const dateFormat = (date) => {
    return new Intl.DateTimeFormat("en-GB", {
      year: "numeric",
      month: "long",
      day: "2-digit",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      hour12: false,
      timeZone: "Asia/Kuala_Lumpur",
    }).format(new Date(date));
  };

  const camelCaseFormat = (str) => {
    let str_split = str.toLowerCase().split("_");
    for (let i = 0; i < str_split.length; i++) {
      str_split[i] =
        str_split[i].charAt(0).toUpperCase() + str_split[i].substring(1);
    }
    return str_split.join(" ");
  };

  return (
    <div className={classes.root}>
      <Grid container direction="column" spacing={1}>
        <Grid item xs={12}>
          {" "}
        </Grid>{" "}
        <Grid item xs={12}>
          {" "}
          {disputeItem ? (
            <Grid container direction="row" justifyContent="space-between" spacing={3}>
              <Grid item xs={5}>
                <Card className={classes.card}>
                  <Grid
                    container
                    direction="row"
                    className={classes.cardHeader}
                  >
                    <Grid item xs={12}>
                      <Typography
                        variant="body1"
                        className={classes.headerText}
                      >
                        {camelCaseFormat(dispute.reason)}{" "}
                      </Typography>{" "}
                    </Grid>{" "}
                    <Grid item xs={12}>
                      <Typography
                        variant="body2"
                        className={classes.headerText}
                      >
                        Case ID: {dispute.dispute_id}{" "}
                      </Typography>{" "}
                    </Grid>{" "}
                  </Grid>{" "}
                  <Grid
                    container
                    direction="row"
                    spacing={1}
                    className={classes.cardBody}
                  >
                    <Grid item xs={12}>
                      <Typography variant="body1">
                        <strong> Case Details </strong>{" "}
                      </Typography>{" "}
                    </Grid>
                    <Grid item xs={12}>
                      <Grid container direction="row">
                        <Grid item xs={5}>
                          <Typography
                            variant="body2"
                            style={{
                              color: "#666666",
                            }}
                          >
                            Create Time{" "}
                          </Typography>{" "}
                        </Grid>{" "}
                        <Grid item>
                          <Typography variant="body2">
                            {" "}
                            {dateFormat(dispute.create_time)}{" "}
                          </Typography>{" "}
                        </Grid>{" "}
                      </Grid>{" "}
                    </Grid>{" "}
                    <Grid item xs={12}>
                      <Grid container direction="row">
                        <Grid item xs={5}>
                          <Typography
                            variant="body2"
                            style={{
                              color: "#666666",
                            }}
                          >
                            Update Time{" "}
                          </Typography>{" "}
                        </Grid>{" "}
                        <Grid item>
                          <Typography variant="body2">
                            {" "}
                            {dateFormat(dispute.update_time)}{" "}
                          </Typography>{" "}
                        </Grid>{" "}
                      </Grid>{" "}
                    </Grid>{" "}
                    <Grid item xs={12}>
                      <Grid container direction="row">
                        <Grid item xs={5}>
                          <Typography
                            variant="body2"
                            style={{
                              color: "#666666",
                            }}
                          >
                            Status{" "}
                          </Typography>{" "}
                        </Grid>{" "}
                        <Grid item>
                          {" "}
                          {dispute.status ? (
                            <Typography variant="body2">
                              {" "}
                              {camelCaseFormat(dispute.status)}{" "}
                            </Typography>
                          ) : (
                            <Typography variant="body2"> N / A </Typography>
                          )}{" "}
                        </Grid>{" "}
                      </Grid>{" "}
                    </Grid>{" "}
                    <Grid item xs={12}>
                      <Grid container direction="row">
                        <Grid item xs={5}>
                          <Typography
                            variant="body2"
                            style={{
                              color: "#666666",
                            }}
                          >
                            Due Date{" "}
                          </Typography>{" "}
                        </Grid>{" "}
                        <Grid item>
                          {" "}
                          {dispute.seller_response_due_date ? (
                            <Typography variant="body2">
                              {" "}
                              {dateFormat(
                                dispute.seller_response_due_date
                              )}{" "}
                            </Typography>
                          ) : (
                            <Fragment>
                              {" "}
                              {/* Buyer Response Due Date */}{" "}
                              {dispute.buyer_response_due_date ? (
                                <Typography variant="body2">
                                  {" "}
                                  {dateFormat(
                                    dispute.buyer_response_due_date
                                  )}{" "}
                                </Typography>
                              ) : (
                                <Typography variant="body2"> N / A </Typography>
                              )}{" "}
                            </Fragment>
                          )}{" "}
                        </Grid>{" "}
                      </Grid>{" "}
                    </Grid>{" "}
                    <Grid item xs={12}>
                      <Grid container direction="row">
                        <Grid item xs={5}>
                          <Typography
                            variant="body2"
                            style={{
                              color: "#666666",
                            }}
                          >
                            Dispute Amount{" "}
                          </Typography>{" "}
                        </Grid>{" "}
                        <Grid item>
                          {" "}
                          {dispute.dispute_amount ? (
                            <Typography variant="body2">
                              {" "}
                              {dispute.dispute_amount.value}{" "}
                              {dispute.dispute_amount.currency_code}{" "}
                            </Typography>
                          ) : (
                            <Typography variant="body2"> N / A </Typography>
                          )}{" "}
                        </Grid>{" "}
                      </Grid>{" "}
                    </Grid>{" "}
                    <Grid item xs={12}>
                      <Grid container direction="row">
                        <Grid item xs={5}>
                          <Typography
                            variant="body2"
                            style={{
                              color: "#666666",
                            }}
                          >
                            Dispute Outcome{" "}
                          </Typography>{" "}
                        </Grid>{" "}
                        <Grid item>
                          {" "}
                          {dispute.dispute_outcome ? (
                            <Typography variant="body2">
                              {" "}
                              {camelCaseFormat(
                                dispute.dispute_outcome.outcome_code
                              )}{" "}
                            </Typography>
                          ) : (
                            <Typography variant="body2"> N / A </Typography>
                          )}{" "}
                        </Grid>{" "}
                      </Grid>{" "}
                    </Grid>{" "}
                    <Grid item xs={12}>
                      <Divider variant="fullWidth" />
                    </Grid>{" "}
                    <Grid item xs={12}>
                      <Typography variant="body1">
                        <strong> Order Details </strong>{" "}
                      </Typography>{" "}
                    </Grid>
                    <Grid item xs={12}>
                      <Grid container direction="row">
                        <Grid item xs={5}>
                          <Typography
                            variant="body2"
                            style={{
                              color: "#666666",
                            }}
                          >
                            Seller Transaction ID{" "}
                          </Typography>{" "}
                        </Grid>{" "}
                        <Grid item>
                          {" "}
                          {dispute.disputed_transactions ? (
                            <Typography variant="body2">
                              {" "}
                              {dispute.disputed_transactions.map(
                                (each, index) => {
                                  return (
                                    <Link
                                      key={index}
                                      href="/"
                                      style={{
                                        color: "#1976d2",
                                      }}
                                      onClick={(event) => {
                                        event.preventDefault();
                                      }}
                                      data-toggle="modal"
                                      data-target="#orderModal"
                                    >
                                      {each.seller_transaction_id}{" "}
                                    </Link>
                                  );
                                }
                              )}{" "}
                            </Typography>
                          ) : (
                            <Typography variant="body2"> N / A </Typography>
                          )}{" "}
                        </Grid>{" "}
                      </Grid>{" "}
                    </Grid>{" "}
                    <Grid item xs={12}>
                      <Grid container direction="row">
                        <Grid item xs={5}>
                          <Typography
                            variant="body2"
                            style={{
                              color: "#666666",
                            }}
                          >
                            Order ID{" "}
                          </Typography>{" "}
                        </Grid>{" "}
                        <Grid item>
                          {" "}
                          {order.length > 0 ? (
                            <Fragment>
                              {" "}
                              {order.map((each, index) => {
                                return (
                                  <Fragment key={index}>
                                    {" "}
                                    {each.name ? (
                                      <Typography variant="body2">
                                        {" "}
                                        {each.name}{" "}
                                      </Typography>
                                    ) : (
                                      <Typography variant="body2">
                                        N / A{" "}
                                      </Typography>
                                    )}{" "}
                                  </Fragment>
                                );
                              })}{" "}
                            </Fragment>
                          ) : (
                            <Typography variant="body2"> N / A </Typography>
                          )}{" "}
                        </Grid>{" "}
                      </Grid>{" "}
                    </Grid>{" "}
                    <Grid item xs={12}>
                      <Grid container direction="row">
                        <Grid item xs={5}>
                          <Typography
                            variant="body2"
                            style={{
                              color: "#666666",
                            }}
                          >
                            Store Name{" "}
                          </Typography>{" "}
                        </Grid>{" "}
                        <Grid item>
                          {" "}
                          {order.length > 0 ? (
                            <Fragment>
                              {" "}
                              {order.map((each, index) => {
                                return (
                                  <Fragment key={index}>
                                    {" "}
                                    {each.store_name ? (
                                      <Typography variant="body2">
                                        {" "}
                                        {each.store_name}{" "}
                                      </Typography>
                                    ) : (
                                      <Typography variant="body2">
                                        N / A{" "}
                                      </Typography>
                                    )}{" "}
                                  </Fragment>
                                );
                              })}{" "}
                            </Fragment>
                          ) : (
                            <Typography variant="body2"> N / A </Typography>
                          )}{" "}
                        </Grid>{" "}
                      </Grid>{" "}
                    </Grid>{" "}
                    <Grid item xs={12}>
                      <Grid container direction="row">
                        <Grid item xs={5}>
                          <Typography
                            variant="body2"
                            style={{
                              color: "#666666",
                            }}
                          >
                            Gateway{" "}
                          </Typography>{" "}
                        </Grid>{" "}
                        <Grid item>
                          {" "}
                          {order.length > 0 ? (
                            <Fragment>
                              {" "}
                              {order.map((each, index) => {
                                return (
                                  <Fragment key={index}>
                                    {" "}
                                    {each.gateway ? (
                                      <Typography variant="body2">
                                        {" "}
                                        {each.gateway}{" "}
                                      </Typography>
                                    ) : (
                                      <Typography variant="body2">
                                        N / A{" "}
                                      </Typography>
                                    )}{" "}
                                  </Fragment>
                                );
                              })}{" "}
                            </Fragment>
                          ) : (
                            <Typography variant="body2"> N / A </Typography>
                          )}{" "}
                        </Grid>{" "}
                      </Grid>{" "}
                    </Grid>{" "}
                    <Grid item xs={12}>
                      <Divider variant="fullWidth" />
                    </Grid>{" "}
                    <Grid item xs={12}>
                      <Typography variant="body1">
                        <strong> Case Actions </strong>{" "}
                      </Typography>{" "}
                    </Grid>{" "}
                    <PaypalFunctionsHome
                      linkProvideSupportInfo={linkProvideSupportInfo}
                      linkAcceptClaim={linkAcceptClaim}
                      linkAppeal={linkAppeal}
                      linkProvideEvidence={linkProvideEvidence}
                      linkEscalate={linkEscalate}
                      linkMakeOffer={linkMakeOffer}
                      linkAcknowledge={linkAcknowledge}
                      dispute={dispute}
                      order={order}
                      setReturnedMsg={setReturnedMsg}
                    />{" "}
                  </Grid>{" "}
                  {/* POPUP ORDER MODAL TOP */}{" "}
                  <div
                    className="modal fade"
                    id="orderModal"
                    tabIndex="-1"
                    role="dialog"
                    aria-labelledby="orderModalLabel"
                    aria-hidden="true"
                  >
                    <div
                      className="modal-dialog modal-xl"
                      style={{
                        zIndex: 11,
                      }}
                    >
                      <div className="modal-content">
                        <div className="modal-header">
                          <h5 className="modal-title" id="orderModalLabel">
                            Order Details{" "}
                          </h5>{" "}
                          <button
                            type="button"
                            className="close"
                            data-dismiss="modal"
                            aria-label="Close"
                          >
                            <span aria-hidden="true"> & times; </span>{" "}
                          </button>{" "}
                        </div>{" "}
                        <div className="modal-body">
                          <DisputeResultOrder order={order} loading={loading} />{" "}
                        </div>{" "}
                        <div className="modal-footer">
                          <button
                            type="button"
                            className="btn btn-secondary"
                            data-dismiss="modal"
                          >
                            Close{" "}
                          </button>{" "}
                        </div>{" "}
                      </div>{" "}
                    </div>{" "}
                  </div>{" "}
                  {/* POPUP ORDER MODAL END */}{" "}
                </Card>{" "}
              </Grid>{" "}
              <Grid item xs={7}>
                <Card className={classes.card}>
                  <Grid
                    container
                    direction="row"
                    alignItems="center"
                    className={classes.cardHeader}
                  >
                    <Typography variant="h6" className={classes.headerText}>
                      Messages{" "}
                    </Typography>{" "}
                  </Grid>{" "}
                  <FunctionSendMessage
                    state={state}
                    setState={setState}
                    setReturnedMsg={setReturnedMsg}
                    disputeMessages={disputeMessages}
                    linkSendMessage={linkSendMessage}
                  />{" "}
                </Card>{" "}
              </Grid>{" "}
            </Grid>
          ) : (
            <Grid
              container
              direction="row"
              alignItems="flex-end"
              justifyContent="center"
              style={{
                height: 250,
              }}
            >
              <Grid item> {loading ? <Spinner /> : null} </Grid>{" "}
            </Grid>
          )}{" "}
        </Grid>{" "}
      </Grid>{" "}
    </div>
  );
};

export default DisputeResult;
